module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "orderDetailContent"
  }, [_c('div', {
    staticClass: "deliveryInfo"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("收货信息")]), _vm._v(" "), _c('div', {
    staticClass: "deliveryContent"
  }, [_c('div', {
    staticClass: "deliveryAddress"
  }, [_c('div', {
    staticClass: "addressInfo"
  }, [_c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("收 货 人：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.memberDetial.nickName))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("联系方式：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.desensitize(_vm.memberDetial.mobile)))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("所在地区：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.memberDetial.province) + " " + _vm._s(_vm.memberDetial.city) + " " + _vm._s(_vm.memberDetial.area))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("详细地址：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.memberDetial.address) + " ")])]), _vm._v(" "), (_vm.orderStatus == 1) ? _c('div', [_c('input', {
    attrs: {
      "type": "button",
      "value": "切换地址"
    },
    on: {
      "click": _vm.changeAddress
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('div', {
    staticClass: "orderLabelName"
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderInfo.orderCode))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "orderLabelName"
  }, [_vm._v("订单状态：" + _vm._s(_vm.orderInfo.status))])]), _vm._v(" "), (_vm.orderStatus == 3 || _vm.orderStatus == 4) ? _c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("物流公司：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.orderInfo.logisticsCompany) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 3 || _vm.orderStatus == 4) ? _c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("物流单号：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.orderInfo.logisticsNo) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 1) ? _c('div', [_c('div', {
    staticClass: "operateLabelName"
  }, [_vm._v("您可以"), _c('input', {
    staticClass: "operateBtn",
    attrs: {
      "type": "button",
      "value": "立即付款"
    },
    on: {
      "click": function($event) {
        return _vm.orderPayment(_vm.orderId)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "operateBtn1",
    attrs: {
      "type": "button",
      "value": "取消订单"
    },
    on: {
      "click": function($event) {
        return _vm._cancelOrder()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 3) ? _c('div', [_c('div', {
    staticClass: "operateLabelName"
  }, [_vm._v("您可以"), _c('input', {
    staticClass: "operateBtn",
    attrs: {
      "type": "button",
      "value": "确认收货"
    },
    on: {
      "click": function($event) {
        return _vm.orderConfirm(_vm.orderId)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), ((_vm.orderStatus == 2 || _vm.orderStatus == 3 || _vm.orderStatus == 4) && _vm.orderInfo.invoiceStatus == '未开票') ? _c('div', [_c('div', {
    staticClass: "operateLabelName"
  }, [_vm._v("您可以"), _c('input', {
    staticClass: "operateBtn",
    attrs: {
      "type": "button",
      "value": "申请发票"
    },
    on: {
      "click": function($event) {
        return _vm.applyInvoice(_vm.orderId)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.invoiceStatus != '未开票') ? _c('div', [_c('div', {
    staticClass: "labelName"
  }, [_vm._v("开票状态：")]), _c('div', {
    staticClass: "labelValue"
  }, [_vm._v(_vm._s(_vm.orderInfo.invoiceStatus) + " "), (_vm.orderInfo.invoiceAnnex) ? _c('a', {
    staticClass: "downloadBtn",
    attrs: {
      "href": _vm.orderInfo.invoiceAnnex,
      "target": "_blank"
    }
  }, [_vm._v("发票下载")]) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "productInfo"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderList), function(item, i) {
    return _c('tr', {
      key: 'product_' + i
    }, [_c('td', {
      staticClass: "productImage"
    }, [_c('img', {
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.goodsDetails(item.productId)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "productName"
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.specName) + ")")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(Number(item.price).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(Number(item.price * item.num).toFixed(2)))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "orderfooter"
  }, [_c('div', {
    staticClass: "productTotal"
  }, [_vm._v("商品总价："), _c('div', [_vm._v("￥" + _vm._s(_vm.productTotal.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "postFee"
  }, [_vm._v("运费(快递)："), _c('div', [_vm._v("￥" + _vm._s(_vm.postFee.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "orderAmount"
  }, [_vm._v("订单总价："), _c('div', [_vm._v("￥" + _vm._s(_vm.orderTotal.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "payAmount"
  }, [_vm._v("实付款："), _c('div', [_vm._v("￥" + _vm._s(_vm.orderTotal.toFixed(2)))])])])]), _vm._v(" "), _c('selectAddress', {
    ref: "selectAddress",
    on: {
      "fetch-data": _vm._getOrderDet
    }
  }), _vm._v(" "), _c('applyInvoice', {
    ref: "applyInvoice",
    on: {
      "fetch-data": _vm._getOrderDet
    }
  })], 1) : _c('div', {
    staticClass: "orderDetailContent1"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "productHead"
  }, [_c('th', {
    staticClass: "productInfo",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('th', {
    staticClass: "productPrice"
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticClass: "productNum"
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticClass: "productTotal"
  }, [_vm._v("总价")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19aa4045","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/OrderDetail.vue
// module id = 744
// module chunks = 2